import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SharedService } from 'src/app/services/shared.service';
import { ModalData } from 'src/app/types/modal-data';

/**
 * launch dialog component
 * serves as a template container for the legacy user onboarding workflow.
 * The component is shown as a modal dialog to start Scope client via web interface.
 * @class LaunchDialogComponent
 * @typedef {LaunchDialogComponent}
 * @implements {OnInit}
 */
@Component( {
    selector: 'app-launch-dialog',
    templateUrl: './launch-dialog.component.html',
    styleUrls: ['./launch-dialog.component.scss'],
    standalone: false
} )
export class LaunchDialogComponent implements OnInit {
    /** reference on choosen server url */
    scopeUrl = '';

    /**  flag, if user has runtime */
    hasRuntime = true;
    /**  flag, if user has downloaded runtime */
    hasDownload = true;

    #sharedService = inject( SharedService );

    /**
     * Creates an instance of LaunchDialogComponent.
     * @class
     * @param data object of data properies passed into the modal
     * @param dialogRef reference on dialog modal
     */
    constructor(
        @Inject( MAT_DIALOG_DATA ) public data: ModalData,
        public dialogRef: MatDialogRef<LaunchDialogComponent>
    ) {
        /** */
    }

    /** start scope instance */
    ngOnInit(): void {
        window.setTimeout( () => {
            this.launchScope();
        }, 125 );
    }

    /** helper function to close dialog */
    closeDialog(): void {
        this.dialogRef.close( 'close' );
    }

    /** helper function to launch scope manually */
    launchScope() {
        this.#sharedService.launchScope( this.data.version!, this.data.url! );
    }
}
